// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../getDayOfYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var getDayOfYear = convertToFP(fn, 1);
export default getDayOfYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/getDayOfYear/index.js
// module id = 891
// module chunks = 0